import { type ConfigData } from "../config-data";

const config: ConfigData = {
	rules: {
		"attr-quotes": "off",
		"doctype-style": "off",
		"void-style": "off",
	},
};

export default config;
